var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewXpossibleFontRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Mar  3 01:50:45 2022\n By Aleksey,,,\n \n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "NewXpossibleFontRegular",
    horizAdvX: 749
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "New Xpossible Font",
    fontWeight: 500,
    fontStretch: "normal",
    unitsPerEm: 2048,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 1638,
    descent: -410,
    xHeight: 775,
    capHeight: 1644,
    bbox: "-234 -666 1796 1690.74",
    underlineThickness: 102,
    underlinePosition: -307,
    unicodeRange: "U+000D-00A0"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 1331
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 1331
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "controlCR",
    unicode: "\r",
    horizAdvX: 722
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 722
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 206,
    d: "M53 105q22 0 37 -15t15 -37t-15 -37.5t-37 -15.5t-37.5 15.5t-15.5 37.5t15.5 37t37.5 15zM68 239h-31l-20 838h72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 272,
    d: "M171 1105l-15 -104h-45l-15 104h75zM75 1105l-15 -104h-45l-15 104h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 1286,
    d: "M1126 399q-161 7 -414 7q-71 -238 -111 -406l-48 14q62 171 131 392h-121q-31 0 -93.5 -1t-94.5 -1q-64 -214 -110 -404l-48 14q52 141 130 389q-187 -3 -347 -13v49q139 -7 356 -7q6 19 18 58.5t18 59.5q6 22 18.5 64t19.5 64q-208 -3 -373 -14v50q169 -8 381 -8 q74 256 106 386l47 -15q-57 -159 -123 -371h152q26 0 77.5 1t77.5 2q67 231 105 383l47 -15q-44 -122 -122 -368q219 5 377 14l1 -50q-206 8 -387 8q-7 -23 -21.5 -69.5t-21.5 -69.5q-6 -18 -17 -53.5t-16 -53.5q272 6 406 14v-50zM417 542q-5 -19 -17 -55.5t-17 -55.5 q30 0 90 0.5t90 0.5q21 0 64 1t65 1q6 20 18 58t18 58q7 22 20 65.5t19 65.5q-25 0 -74 -0.5t-73 -0.5q-27 0 -80.5 -1t-80.5 -1q-7 -23 -21 -68t-21 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 817,
    d: "M714 1469q-83 -167 -174 -359l-168 -361l-165 -363q-99 -221 -160 -365l-47 22q83 167 174 359l168 361l165 363q99 221 160 365zM435 105q0 -43 -30.5 -74t-74.5 -31t-74.5 31t-30.5 74q0 44 31 75t74 31t74 -31t31 -75zM435 1375q0 -43 -30.5 -74t-74.5 -31t-74.5 31 t-30.5 74t30.5 74t74.5 31t74.5 -31t30.5 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1343,
    d: "M1065 904q35 -196 10 -339t-91 -237.5t-161 -144.5t-199.5 -61.5t-207 12t-183.5 76.5q-118 77 -158.5 222.5t25.5 272.5q75 142 325 270q306 158 306 261q0 99 -53.5 163.5t-162.5 64.5q-56 0 -100.5 -23.5t-70 -61t-38 -79t-12.5 -82.5q1 -100 37.5 -203t95.5 -190.5 t118.5 -155.5t123.5 -125q209 -185 573 -298l-63 -108q-130 50 -260 125t-220 155q-114 103 -200.5 205t-157.5 234q-114 212 -91 374q13 95 92 174.5t168 79.5q97 0 170.5 -66.5t73.5 -182.5q0 -42 -13.5 -78.5t-32 -62t-51.5 -52.5t-57 -42.5t-64 -38.5 q-38 -22 -111 -60.5t-115 -62.5t-91.5 -65.5t-80.5 -88.5q-66 -109 -53 -212t88 -184.5t184 -113.5q102 -30 208.5 -24.5t203.5 49t160 131.5t78.5 223.5t-40.5 325.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 176,
    d: "M75 1105l-15 -104h-45l-15 104h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 497,
    d: "M393 1375q-75 -38 -156 -119q-67 -70 -119 -161q-95 -169 -97 -386q0 -212 98 -386q50 -88 120 -161q79 -79 155 -123l-24 -39q-86 61 -156 140q-71 80 -118 170q-49 93 -73 194q-23 96 -23 205t23 205q25 105 71 194q47 90 118 171q80 89 159 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 497,
    d: "M23 1416q81 -50 160 -137q71 -81 118 -171q46 -89 71 -194q23 -96 23 -205q0 -105 -24 -205q-24 -101 -73 -194q-47 -90 -118 -170q-72 -81 -155 -140l-25 39q78 45 156 123q67 70 119 161q98 174 98 386q-2 219 -96 386q-52 91 -119 161q-81 81 -156 119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 563,
    d: "M461 1327l-180 -31l127 -132l-92 -66l-86 161l-85 -161l-92 66l127 132l-180 31l35 108l164 -80l-25 181h113l-25 -181l164 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 641,
    d: "M539 720v-36q-120 11 -262 11q0 -142 11 -262h-36q10 109 10 262q-142 0 -262 -11v36q109 -10 262 -10q0 153 -10 262h36q-11 -120 -11 -262q153 0 262 10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 241,
    d: "M136 85q3 -24 -1 -45q-7 -28 -23 -43q-18 -16 -43 -21q-19 -5 -49 -3l5 21q19 -9 42 -7q22 2 38 18q11 11 16 27q-21 -24 -52 -24q-29 0 -49 20t-20 48t20 48.5t49 20.5q26 0 44.5 -17.5t22.5 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 239,
    d: "M137 69q0 -29 -20 -49t-48 -20q-29 0 -49 20t-20 49q0 28 20 48t49 20t48.5 -19.5t19.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 811,
    d: "M708 1436q-76 -152 -172 -356l-167 -358l-164 -360q-86 -190 -158 -362l-47 22q35 70 172 356l167 358l164 360q86 190 158 362z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 966,
    d: "M336 75q99 -23 196.5 27t169 158t97.5 249t-1 271.5t-99 219t-171 111.5q-74 17 -149.5 -8.5t-137.5 -83.5t-108.5 -147.5t-66.5 -194.5q-26 -141 1 -271.5t98.5 -219t170.5 -111.5zM432 1131q118 0 217.5 -72t157.5 -196t58 -270t-58 -270t-157.5 -196t-217.5 -72 t-217.5 72t-157 196t-57.5 270t57.5 270t157 196t217.5 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 518,
    d: "M416 36v-20v-1h-416v1v20v16q83 -10 193 -11v1004q-32 -18 -60.5 -48t-40.5 -51l-13 -21l-25 26l139 139v1h36v-1050q110 2 187 11v-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 837,
    d: "M735 84v-69h-663h-71h-1l5 35l1 1q31 95 84 173.5t114.5 134.5t122.5 106t124 112t103 128q26 43 32.5 99.5t-7.5 104.5q-18 64 -85 113t-155 48q-103 -1 -174 -75.5t-58 -202.5l-72 -12q0 78 27 140.5t72 99t98.5 54.5t109.5 16q138 -3 224 -88q66 -65 69.5 -164 t-51.5 -172q-44 -60 -106.5 -122t-118 -110.5t-110 -101t-98.5 -115.5t-67 -133q22 -2 59.5 -5.5t137.5 -10t182 -8.5t162.5 3.5t109.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 876,
    d: "M483 626q145 -29 216 -120t52 -206q-12 -75 -48 -133t-83 -89.5t-93.5 -47.5t-88.5 -16q-206 -1 -321.5 97t-116.5 295l72 -4q-10 -93 17.5 -167.5t78 -117.5t116 -64.5t130.5 -17t123 34t92 79.5q12 15 24.5 39.5t25.5 63t11.5 87.5t-19.5 97q-32 83 -130.5 127 t-189.5 22l-6 78q43 -6 91.5 13.5t86.5 56.5t61.5 82t17 96.5t-48.5 93.5q-47 47 -109 59.5t-116.5 -9t-92 -83.5t-37.5 -152l-72 -9q0 67 26.5 124t71.5 92t100 51.5t117.5 5.5t118.5 -48q71 -48 85.5 -130.5t-30 -162t-132.5 -117.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 880,
    d: "M100 301l432 -1v691zM779 249h-220v-233h-27v234q-476 0 -487 -1v1l-45 -1l532 838h27v-783l218 -1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 933,
    d: "M583 676q74 -40 119 -123.5t44.5 -185t-53.5 -185.5q-48 -74 -119.5 -116.5t-147 -49.5t-151.5 15t-134.5 68.5t-93.5 120t-31 161.5h53q-7 -61 7.5 -114.5t45 -91.5t73 -67t92 -41.5t102 -15.5t103.5 11q81 20 135 65t75 100t21.5 117.5t-18.5 118.5t-51.5 101.5 t-71.5 67.5q-52 29 -145.5 40t-161.5 8l-68 -4v414l364 1l1 -55q-57 16 -140.5 20.5t-137.5 1.5l-55 -4v-314q15 -1 62 -2.5t62.5 -2.5t52.5 -5t58 -10t51 -17t58 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 702,
    d: "M477 878q0 112 -84 169q-75 50 -165 28q-98 -24 -143 -120q-29 -62 -29 -143q0 -68 -2.5 -231t-2.5 -247q0 -131 59.5 -211.5t181.5 -86.5q63 -3 123.5 27.5t103.5 98.5t43 157q0 73 -29.5 133t-79.5 92t-109 39t-126 -26.5t-123 -104.5l-40 37q143 135 312 113 q101 -14 167 -92t66 -191q0 -41 -10 -82.5t-32.5 -82t-55 -71.5t-82 -50t-108.5 -19q-146 0 -232 86q-23 23 -38.5 54t-23 55t-11.5 65.5t-4 58v60.5q0 46 -1.5 197t-1.5 216q0 129 68.5 207.5t212.5 78.5q27 0 51 -3t58.5 -16.5t60.5 -35.5t47 -65.5t27 -101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 694,
    d: "M0 1091h592l-379 -1076h-50l369 1037q-10 2 -37.5 4.5t-163 -1.5t-331.5 -22v58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 704,
    d: "M302 31q109 -1 188.5 79t79.5 223q0 72 -23 130.5t-60.5 94.5t-85.5 55.5t-97.5 19.5t-97.5 -19.5t-85.5 -55.5t-60.5 -94.5t-23 -130.5q0 -142 78.5 -221.5t186.5 -80.5zM167 719q53 -70 134 -70q82 0 134 69q49 64 47 143q0 81 -48 143q-51 68 -133 68q-81 0 -133 -69 q-47 -62 -47 -142q-2 -79 46 -142zM357 644q104 -19 174 -99t72 -212q-2 -101 -46.5 -174.5t-111 -107t-143.5 -33t-143.5 33.5t-111.5 107t-47 174q2 131 72 211.5t173 99.5q-69 20 -115.5 81.5t-45.5 135.5q2 97 63 160q65 69 154 67q87 1 151.5 -68.5t62.5 -158.5 q1 -73 -44.5 -134.5t-113.5 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 702,
    d: "M82 244q0 -110 90 -171q82 -54 181 -36q107 19 158 112q33 61 33 144q0 68 3 231t3 247q0 130 -59.5 211t-182.5 87q-63 3 -123.5 -27.5t-103.5 -98t-43 -156.5q0 -61 21 -113t56.5 -87t83 -52t98.5 -12t106 38t102 92l40 -37q-142 -134 -311 -112q-102 14 -168 91.5 t-66 190.5q0 41 10 82.5t32.5 82t55 71.5t82 50t108.5 19q146 0 232 -86q28 -28 45.5 -63.5t24 -81.5t7.5 -71.5t1 -76.5q0 -46 1 -196.5t1 -215.5q0 -129 -68.5 -207.5t-212.5 -78.5q-28 0 -56 3t-69 16.5t-72.5 35.5t-57.5 65.5t-32 101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 208,
    d: "M108 343q0 -29 -20 -49t-49 -20q-28 0 -48 20t-20 49t19.5 48.5t48.5 19.5t49 -20t20 -48zM108 69q0 -29 -20 -49t-49 -20q-28 0 -48 20t-20 49t19.5 48.5t48.5 19.5t49 -20t20 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 241,
    d: "M136 114q3 -25 -1 -46q-7 -27 -23 -42q-19 -18 -43 -22q-19 -5 -49 -3l5 21q19 -9 42 -7q22 2 38 18q11 11 16 27q-21 -24 -52 -24q-29 0 -49 20t-20 48t20 48.5t49 20.5q26 0 44.5 -17t22.5 -42zM138 379q0 28 -20 48t-49 20t-49 -20t-20 -48q0 -29 20 -49t49 -20t49 20 t20 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 690,
    d: "M587 1415l-552 -696l552 -696l-30 -23l-538 700v-1l-19 15l4 5l-4 5l19 15v-1l538 700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 786,
    d: "M684 564q-135 13 -342 13t-342 -13v45q135 -13 342 -13t342 13v-45zM684 795q-135 13 -342 13t-342 -13v45q135 -13 342 -13t342 13v-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 690,
    d: "M0 23l552 696l-552 696l30 23l538 -700v1l19 -15l-4 -5l4 -5l-19 -15v1l-538 -700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 710,
    d: "M330 51q0 -21 -15 -36t-36 -15t-36 15t-15 36t15 36t36 15t36 -15t15 -36zM304 437v-193h-46v223q7 0 18.5 1.5t45.5 8.5t64.5 18.5t68 36t64 56t44 82t16.5 112.5q-1 73 -26 128t-57.5 83t-75 45.5t-70.5 21.5t-52 4q-55 0 -98.5 -18.5t-68 -44.5t-41 -62t-22.5 -64 t-8 -57h-60q0 99 86 179t211 80q75 0 135.5 -26t98 -69t57 -95.5t19.5 -108.5q0 -66 -16.5 -120.5t-43.5 -89t-59 -60.5t-64.5 -39t-59.5 -21t-44 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1132,
    d: "M976 298l54 -45q-148 -139 -265.5 -194.5t-285.5 -46.5q-205 10 -342 138t-137 341q0 99 35.5 181t94.5 136t136 88t158 42t162.5 -8t149 -54.5t117.5 -106t67 -155.5q10 -40 6.5 -84t-12.5 -86.5t-32.5 -80t-54.5 -64.5t-76.5 -40.5t-99.5 -8.5l-3 336 q-48 45 -103.5 67.5t-104.5 19t-89.5 -23.5t-64.5 -61t-25 -93q-1 -142 127 -178q38 -11 83 1.5t76.5 43.5t32.5 68l53 -4q-6 -57 -50 -97t-98 -49t-107 4q-66 21 -104 67.5t-44 99t10.5 105t53.5 88.5q41 41 92.5 55.5t105.5 5t103.5 -31.5t98.5 -55v-16l1 -302 q70 -5 133 78.5t63 168.5t-29 153t-73.5 109t-101.5 68.5t-109.5 38t-101.5 10.5q-75 0 -151.5 -31.5t-139.5 -85t-102.5 -134t-39.5 -170.5q0 -24 2 -48t17 -79.5t41 -102.5t82.5 -99.5t133.5 -86.5q153 -67 347.5 -5t309.5 214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1445,
    d: "M427 946h502q-231 660 -235 660q-3 0 -135.5 -329t-131.5 -331zM709 1686q465 -1307 519 -1449q34 -89 63 -148t41 -74l12 -15h-85l-322 925q-518 0 -519 -1l-375 -924h-43l695 1686h14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1126,
    d: "M678 108q93 46 154 120.5t82 158t14.5 168.5t-44.5 160t-99 125q-46 37 -104 62.5t-105.5 37t-119 16t-107.5 3.5t-110.5 -4.5t-90.5 -4.5v-874q7 -1 47 -4.5t56.5 -4.5t58 -3.5t65.5 -2.5h63t66.5 3.5t60.5 8.5t61 14t52 21zM148 1639v-627q90 -1 191.5 12t164.5 47 q95 52 134 145.5t19.5 186.5t-84.5 154q-34 32 -79 51.5t-98 26t-89.5 8t-91.5 -1t-67 -2.5zM691 941q114 -54 181.5 -157.5t78 -217t-27 -227.5t-119.5 -192q-33 -31 -72 -55t-73 -39.5t-88 -26t-89.5 -16t-107.5 -8t-110.5 -3t-128.5 -0.5h-47v970v38v4v673 q147 7 249.5 -2.5t168.5 -44.5q97 -52 142 -159.5t24 -221t-103 -182.5q-57 -49 -129 -72q152 -14 251 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1552,
    d: "M1308 603h56q-35 -135 -108 -252q-116 -186 -290 -277.5t-362.5 -69.5t-342.5 156t-228 339.5t-52.5 429t137.5 409.5t290 277.5t362.5 69.5t342.5 -156q139 -122 215 -308h-62q-26 63 -55 113q-101 172 -269.5 255.5t-348.5 57t-313 -158.5q-133 -133 -196 -331.5 t-42.5 -411t121.5 -385.5q75 -129 194.5 -209.5t247.5 -101t259.5 19t230.5 138.5q154 152 213 396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1351,
    d: "M809 248q164 133 238 322.5t45 392.5t-155 377q-44 60 -105.5 109t-131 81.5t-146.5 54.5t-155.5 31.5t-153.5 9t-145 -10.5v-1522q209 -36 390 4t319 151zM790 1540q190 -134 280 -343.5t61 -437t-172 -413.5q-161 -210 -382 -291.5t-548 -42.5v1671q183 10 316.5 3 t238 -40.5t206.5 -105.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 1171,
    d: "M0 1629q48 -2 65 -2q88 -5 252.5 -4.5t347.5 14.5q58 4 128.5 16t87.5 22q14 -45 27 -82q-91 -2 -304.5 -2t-381.5 1l-167 1v-618q378 -10 609 26q1 -8 2.5 -20.5t3 -21.5t1.5 -11q-574 2 -616 0q0 -169 -1 -446.5t-1 -445.5q28 -4 102.5 -8.5t203 -7t315 7.5t376.5 34 l20 -81h-1070v1628z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 983,
    d: "M823 1029l21 -67h-719l4 -802q0 -14 2 -36t12.5 -65.5t28.5 -58.5h-113v1638q28 -1 52 -2.5t51 -1.5q129 -10 305 0.5t287 25.5l112 16l17 -94h-759v-585q147 -12 349.5 -1t349.5 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1574,
    d: "M1312 -33l27 561q-33 -92 -85 -175q-116 -186 -289.5 -277.5t-361.5 -69t-342 156.5t-228 339t-52.5 428.5t137.5 409.5q69 111 169 190.5t213 116.5t231 39.5t232.5 -39.5t206.5 -122q140 -122 215 -307h-61q-24 60 -55 112q-60 103 -153 176.5t-199.5 105.5 t-216.5 31.5t-214.5 -43.5t-183.5 -122q-133 -133 -195.5 -330.5t-42 -410t121.5 -385.5q101 -172 264 -252.5t337 -51.5t307 162q145 145 207 371l-426 -31l-3 66l496 -1l4 -649z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 1210,
    d: "M148 1686v-684q150 -9 398 -9q242 0 416 10v635l60 48v-1683h-60v963q-191 11 -416 11q-232 0 -398 -10v-964h-60v1635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 708,
    d: "M293 1604q-2 -159 -5.5 -326.5t-3 -202.5t2.5 -248q8 -409 18 -790l186 11v-48h-432v48l196 -11q5 81 4 416.5t-1 368.5q1 285 -0.5 384t-10.5 398l-188 -8v48h432v-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 868,
    d: "M709 556q0 -48 -4 -94.5t-15 -103.5t-29.5 -106t-50 -96.5t-73 -81t-102.5 -54t-134 -20.5q-76 0 -141 24.5t-105.5 61t-61 61t-30.5 43.5q-15 25 -31.5 75t-19.5 74h76q3 -35 12 -73t32 -84t56 -81t89 -59t126 -24q23 0 47 3.5t59.5 17t66.5 35t63.5 62.5t56 95t39 136 t16.5 182v1104l-503 -49l-2 75l563 -7v-14v-1102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1105,
    d: "M1005 0h-87l-791 936v-936h-68v1652l68 34v-664l60 -70l684 652l36 -39l-712 -622z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 1052,
    d: "M44 28q0 -4 -4.5 -6t-8.5 1t-2 7.5t7 4.5q75 -2 193 -3.5t365.5 7t355.5 32.5v-71l-934 1l-16 1685h77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1568,
    d: "M719 354l661 1332l-4 -1686l-46 12l3 1462l-608 -1235h-18l-601 1235l3 -1462l-46 -12l-4 1686z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 1288,
    d: "M1071 1611l56 76v-1685h-56l-2 -2q-22 41 -64.5 117t-52.5 95l-121 210q-81 140 -247 416q-168 276 -254 412l-129 205q-14 22 -43 66t-43 66v-1587h-56v1685h56l2 2q21 -40 62 -112.5t56 -99.5l121 -210q106 -184 246 -416q168 -276 254 -412l129 -205q14 -22 42.5 -66 t43.5 -66v1511z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1589,
    d: "M378 110q100 -50 212 -60t221.5 20t211 92t188 158t146.5 215q74 149 93.5 309t-13.5 299t-117.5 254t-209.5 177q-100 50 -212 59.5t-221.5 -20.5t-211.5 -91.5t-188.5 -158t-146.5 -215.5q-74 -149 -93.5 -308.5t14 -298.5t118 -254t209.5 -177zM898 1671 q122 -23 228.5 -86.5t183 -155.5t128 -209.5t64 -247.5t-10.5 -269q-42 -225 -177.5 -397.5t-328 -251.5t-395.5 -41q-122 23 -228.5 86.5t-183 155.5t-128 209t-64 247t10.5 269q31 169 119 311.5t208.5 235t271 132.5t302.5 12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1173,
    d: "M1053 1295q34 -287 -177 -435q-118 -82 -294.5 -104.5t-377.5 19.5l25 61q41 -16 102 -26.5t136.5 -11t153 10.5t150 42.5t129 79t90.5 125.5t33 177q-1 116 -71.5 208.5t-189.5 141.5t-275.5 54.5t-330.5 -52.5l2 -1585h-70v1637q13 5 36 11.5t92.5 20.5t138 19.5 t162 -2.5t174.5 -35q149 -50 248 -138.5t114 -217.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1771,
    d: "M759 129q115 0 215 36q-73 64 -103 89.5t-94.5 75.5t-106 72.5t-98.5 44t-110 26.5q-45 4 -86.5 -9.5t-66 -38t-31 -56t19.5 -62.5q199 -178 461 -178zM48 875q0 -325 209 -529q-7 46 52 103.5t162 60.5q81 2 156.5 -22.5t147 -77t122.5 -101t124 -126.5 q200 84 323.5 272.5t122.5 421.5q0 155 -50.5 293.5t-140.5 241.5t-225 160.5t-295 49.5q-145 -7 -275.5 -67.5t-226 -158.5t-151 -234t-55.5 -287zM1559 224l112 -25q-33 -71 -88 -125.5t-126.5 -85.5t-162.5 -14.5t-182 88.5q-16 12 -98 85q-120 -59 -247 -77t-252 8.5 t-231 98.5q-166 113 -244 301.5t-51 405t155 405.5q95 140 234.5 234t286.5 128.5t296 15t268 -94.5q122 -77 197.5 -208t95.5 -281.5t-18 -316t-134 -306.5q-130 -193 -329 -299q3 -3 12.5 -15t15.5 -17q321 -312 487 89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1177,
    d: "M965 1008q-67 -122 -216 -194q-85 -41 -189 -62q105 -11 187 -52q26 -13 41 -22t49 -37.5t55 -60t41.5 -87.5t25.5 -123l35 -369h-85l-1 314q0 91 -23.5 162t-51 109t-76 67.5t-72.5 37.5t-66 19q-5 1 -7 2q-93 24 -163 24q-145 -11 -273 18l25 81q114 -44 265 -41 q144 5 266 57q65 28 116 70q54 45 87 103t42 127q10 75 -1 136q-12 67 -49 125q-34 55 -90 99q-102 80 -249 108q-65 13 -136 13q-68 0 -137 -9q-94 -12 -186 -41v-1581l-70 -3v1634q137 39 199 47q25 3 51 5q164 10 289 -20q71 -17 138 -47q70 -32 124 -76 q58 -47 97.5 -111.5t51.5 -136.5q12 -71 1 -146q-9 -75 -45 -139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 1290,
    d: "M902 1387q15 71 -17.5 130.5t-93 93.5t-132.5 49.5t-136 6.5q-74 -10 -133.5 -51.5t-93 -99t-44.5 -126.5t3.5 -133.5t60.5 -121.5t118 -89q54 -24 106.5 -39t133 -31.5t115.5 -24.5q87 -21 164.5 -61t141 -106.5t83.5 -144.5q36 -143 -2 -268.5t-130.5 -209t-231 -127 t-297.5 -31.5q-129 10 -235.5 56.5t-174 115.5t-101.5 157t-27.5 178t57.5 181.5t145 164.5l44 -61q-89 -77 -133 -160t-44 -157.5t32 -145.5t90.5 -126t137 -96t165.5 -60t182 -13t181 41q77 31 134 79.5t88.5 104t45.5 120t11 128.5t-21 129q-31 113 -159.5 199 t-320.5 123q-295 56 -384 191q-38 57 -49.5 123t8 137.5t70.5 134.5q48 59 121 94t150.5 43t157 -8.5t142 -54t103.5 -101t43 -141.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1398,
    d: "M973 1666q201 7 324 20v-97q-139 14 -324 21q-54 2 -162 4l-145 1l31 -1615h-97l31 1615q-205 -2 -307 -6q-201 -7 -324 -20v97q123 -13 324 -20q108 -4 325 -6l162 2q108 2 162 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 1345,
    d: "M1184 1686l1 -1147q0 -117 -29.5 -209.5t-80 -153t-122 -100.5t-151 -57t-171.5 -17q-94 0 -177.5 19.5t-156.5 61.5t-125.5 104t-82.5 152t-30 200v1113l78 34l1 -1201q0 -144 67.5 -251.5t178 -160.5t247.5 -55q217 -2 349 116t132 351l1 1167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1269,
    d: "M561 213l482 1473h66l-566 -1686l-484 1686h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1898,
    d: "M1749 1686h47l-559 -1686l-340 1257l-341 -1257l-556 1686h45l505 -1552l327 1234h43l325 -1231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1482,
    d: "M1381 106l-71 -106l-615 759l-610 -756l-22 18l613 761l-676 835l104 67q61 -134 227 -367t379 -493l630 781l22 -19l-633 -785q195 -237 374 -428t278 -267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1220,
    d: "M1074 1683h45l-520 -899v-784h-80v784l-519 899h102l467 -809l17 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1495,
    d: "M1051 66q207 7 341 19v-92q-134 12 -341 19q-58 2 -170 4l-171 2q-170 0 -341 -6q-239 -8 -369 -19l1180 1602q-95 8 -213 13q-46 2 -138 4l-138 2q-137 0 -275 -6q-169 -7 -276 -19v92q107 -12 276 -19q138 -6 275 -6l138 2q92 2 138 4q261 11 313 17l-1121 -1604 q105 -6 210 -9q171 -6 341 -6l171 2q112 2 170 4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 811,
    d: "M47 1458q72 -172 158 -362l164 -360l167 -358q137 -286 172 -356l-47 -22q-72 172 -158 362l-164 360l-167 358q-96 204 -172 356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 757,
    d: "M655 0q-136 15 -327 15q-192 0 -328 -15v52q145 -16 328 -16q182 0 327 16v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 741,
    d: "M639 37q-68 -27 -101 -34l2 130q-48 -53 -121 -89.5t-158 -36.5q-125 0 -192 70q-70 72 -66 162q5 103 73 158q40 31 96.5 46t117.5 10.5t122 -40t102 -98.5l-48 -18q-21 35 -51.5 62t-72 45t-96.5 17.5t-116 -22.5q-49 -17 -79 -59.5t-30 -98.5q0 -32 12 -65.5t37.5 -67 t75 -54.5t115.5 -21q42 0 80.5 9t75.5 31t64.5 56t44 87.5t16.5 120.5q0 88 -1.5 130.5t-8 100.5t-22.5 93.5t-43 61.5q-42 39 -109 45.5t-128.5 -15.5t-106.5 -75.5t-46 -123.5h-54q20 103 99 165t192 62q75 0 130.5 -26.5t87.5 -73t47 -104t15 -125.5v-237 q-3 -136 45 -178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 718,
    d: "M616 371q2 -93 -66 -188.5t-194 -139.5q-47 -17 -103.5 -23.5t-104.5 -4t-89 7.5t-65 10l-23 5v1425h43l-1 -1390q178 -33 307.5 -0.5t202.5 111.5t74 184q0 79 -28.5 141t-75 99t-104.5 60t-119 28.5t-116 0t-97 -22.5l-13 44q132 26 243.5 7.5t190.5 -74.5 q72 -52 104 -119.5t34 -160.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 784,
    d: "M657 281h25q-19 -69 -49 -117q-53 -86 -133.5 -128t-167.5 -32t-158 72q-109 94 -128 253.5t62 289.5q53 86 133.5 128t167.5 32t158 -72q65 -56 99 -141h-29q-10 25 -25 51q-46 79 -124 118t-161 26.5t-144 -73.5q-94 -94 -109.5 -246t55.5 -273q46 -79 124 -118 t161 -26.5t144 73.5q72 72 99 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M3 371q2 93 34 160.5t104 119.5q79 56 190.5 74.5t243.5 -7.5l-14 -44q-36 14 -81.5 21t-97 4t-102.5 -14.5t-98 -38t-82.5 -63t-56.5 -92t-21 -123.5q1 -105 74 -184t202.5 -111.5t307.5 0.5l-1 1390h43v-1425q-9 -2 -24.5 -5.5t-62 -9.5t-91 -7.5t-102.5 4.5t-105 23 q-126 44 -194 139.5t-66 188.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 829,
    d: "M662 339l65 6q-17 -160 -120 -250t-249 -90q-94 0 -169.5 37t-118.5 104q-34 53 -50.5 133t-8.5 145q11 83 44 147.5t79 102.5t101 60.5t111 25t108.5 -8.5t93.5 -35q74 -43 116 -117t46 -162v-11v-1v-1l-649 -1v13l637 1q-16 118 -114.5 203t-225.5 85q-138 0 -226 -91 t-96 -226q-9 -157 79 -257.5t253 -100.5q131 0 212.5 71.5t81.5 217.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 733,
    d: "M668 1398q43 -35 81 -106l-44 -14q-19 67 -62.5 109t-96 50.5t-104.5 -4t-94 -54.5t-59 -102q-16 -56 -21 -143.5t-3 -164.5t-1 -161q162 2 277 18v-59q-115 16 -276 18q2 -86 5.5 -361.5t10.5 -419.5l-49 -1q4 88 1.5 391t-1.5 391q-152 -2 -261 -18v59q107 -16 260 -18 q1 65 0 120.5t0.5 125t5.5 120.5q2 83 44.5 151.5t104.5 103t139 29.5t143 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1081,
    d: "M150 521q-25 -67 -17.5 -125.5t34.5 -110.5t74 -92.5t102 -70t118.5 -43t123.5 -12t116.5 23.5t97.5 63q39 49 40 106.5t-44 116.5q-7 7 -20 20.5t-21.5 22.5t-20 23.5t-15 25.5t-6 28.5t6.5 30.5q17 36 63 59q-67 63 -161 97.5t-186 33t-171.5 -51.5t-113.5 -145z M867 263q29 93 10.5 168t-77.5 138q-14 -10 -21 -16q-44 -60 12 -109q41 -37 58.5 -93.5t6.5 -112.5q8 16 11 25zM926 -127q57 -31 78 -96.5t4.5 -133.5t-60.5 -114q-72 -81 -163 -119t-213 -52q-103 -12 -200.5 2.5t-176 51t-133 96.5t-76.5 133.5t-1 167.5t88 194l66 -63 q-71 -43 -99.5 -117t-15.5 -145.5t53.5 -133t96.5 -84.5q88 -39 199 -52.5t215 -1t191.5 57t127.5 114.5q46 93 42.5 147t-40 88.5t-92.5 49t-116 27t-109 23t-72 37.5t-5 70q-97 9 -187 62.5t-144.5 135.5t-62.5 183t58 204q58 90 145 130t174.5 31t170.5 -53t141 -114 q7 3 28 10.5t29 10.5t24 11.5t21.5 15.5t13 19.5t7 27t-5 34.5t-15.5 45l72 8q-6 -50 -15.5 -81.5t-26 -49t-30.5 -25t-42.5 -19.5t-47.5 -23q43 -58 62 -121.5t9 -137.5t-55 -144q-58 -89 -139.5 -128t-173.5 -33q-8 -33 15.5 -52t71 -27t100 -13.5t113.5 -18.5t101 -35z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 747,
    d: "M559 2l-46 1l-1 467q-4 63 -29 108t-61.5 65.5t-80 23.5t-83 -11t-71 -45t-44.5 -72q-12 -517 25 -532h-80v1411l47 39l8 -903q18 48 56 79.5t83.5 42t94.5 3t89 -31.5t65.5 -67t25.5 -97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 278,
    d: "M138 219q2 -72 4 -108q1 -36 5 -108h-65q4 72 5 108q2 36 4 108q4 144 5 216l4 168q0 59 -5 129l-7 -7q-24 -26 -35 -40q-5 -7 -17 -20.5t-18.5 -21.5t-15 -20t-14.5 -24l-47 47q12 6 25 14t21 14.5t22 18t20 16.5q8 6 22 18.5t18 16.5q14 12 40 36l1 -1l30 1 q-10 -80 -10 -177l3 -168q1 -72 5 -216zM115 1065q26 0 44 -18t18 -43q0 -26 -18.5 -44t-43.5 -18t-43.5 18t-18.5 44q0 25 18 43t44 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 512,
    d: "M354 1043q24 0 41 -16.5t17 -40.5t-17 -40.5t-41 -16.5t-40.5 16.5t-16.5 40.5t16.5 40.5t40.5 16.5zM350 778h23v-782q0 -216 -79 -331.5t-233 -113.5q-80 2 -146 38.5t-106 103.5q-33 56 -43 128h43q2 -28 10.5 -58.5t28 -67t47 -65t73 -48t101.5 -19.5q18 0 37.5 3.5 t48 14.5t53.5 30t50.5 53.5t43 79.5t28 113.5t8.5 151.5v727l-8 -8q-11 -12 -33 -38q-5 -6 -20 -23t-24 -29.5t-16 -26.5l-43 43q11 5 23 13t19 13.5t20.5 17t18.5 15.5q7 6 19.5 17.5t17.5 15.5q13 11 37 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 751,
    d: "M600 3l-451 430q0 -333 15 -430h-47v1421l32 33v-983l45 -43l324 350l35 -35l-351 -324l447 -419h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 348,
    d: "M158 3h-41v1414l41 40v-1454z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1239,
    d: "M117 721q-12 3 -28 -22.5t-25.5 -54t-7.5 -33.5l-56 27q12 19 27.5 37.5t38.5 36.5t44.5 23t44.5 -11.5t40 -58.5q17 44 68 77.5t119 37.5q39 2 79 -5t78 -25.5t62 -55.5t24 -88q15 83 82.5 127t143.5 44q34 0 68.5 -9t73 -31t63 -69t24.5 -113v-552h-53v572 q0 89 -56 139.5t-124 50.5q-87 0 -148.5 -50t-61.5 -136v-576h-56l2 552q0 212 -202 212q-20 0 -47.5 -6.5t-60 -21t-54 -45t-21.5 -71.5v-620h-47l1 614q0 54 -5.5 75.5t-29.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 786,
    d: "M402 781q93 0 158.5 -57t65.5 -149v-572h-50v572q0 96 -58 143.5t-131 46.5q-69 -1 -132.5 -40.5t-63.5 -102.5v-619h-44l-1 663q0 58 -32 57q-31 0 -59 -47q-15 -25 -22 -55l-33 24q24 38 51 61.5t53 30.5t49 -11t36 -61q22 50 81 83t132 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 872,
    d: "M215 53q118 -59 250.5 -1t202.5 198q46 92 47 189t-41.5 175t-119.5 116q-118 59 -250.5 1t-202.5 -198q-46 -92 -47 -189t41.5 -175t119.5 -116zM456 775q143 -26 223 -157t51 -290t-151.5 -252.5t-265.5 -67.5t-223 157.5t-51 290.5t151.5 252t265.5 67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M646 425q-2 -92 -34 -159.5t-105 -119.5q-79 -56 -190.5 -74.5t-243.5 7.5l14 44q42 -17 97 -22.5t115.5 -0.5t119 28.5t105 60t74.5 98.5t28 141q-1 105 -74 184.5t-202.5 112t-307.5 -0.5l1 -1390h-43v1424q9 2 24.5 5.5t62 9.5t91 7.5t102.5 -4.5t105 -23 q86 -30 147.5 -87.5t88.5 -119.5t25 -121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M3 425q-2 93 66 188.5t194 139.5q47 17 103.5 23.5t104.5 4t89 -7.5t64 -10l24 -5v-1424h-43l1 1390q-178 33 -307.5 0.5t-202.5 -112t-74 -184.5q0 -79 28 -141t74.5 -98.5t105 -60t119 -28.5t115.5 0.5t97 22.5l14 -44q-132 -26 -243.5 -7.5t-190.5 74.5 q-72 52 -104 119.5t-34 159.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 724,
    d: "M524 728q54 -36 99 -122l-60 -17q-4 68 -43.5 111.5t-92.5 50t-106 -8.5t-89.5 -66t-36.5 -122v-541h-54v525q0 36 -14 61.5t-31.5 31t-34 -16.5t-20.5 -71l-41 12q17 49 46 71.5t57.5 14.5t45.5 -41q20 60 64 102t96 58.5t109.5 8.5t105.5 -41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 608,
    d: "M392 642q14 64 -47.5 101.5t-127.5 28.5q-41 -6 -72 -31.5t-43.5 -61t-11.5 -72.5t24 -70.5t62 -51.5q25 -11 49.5 -18t61 -14.5t53.5 -11.5q63 -15 114.5 -52.5t64.5 -90.5q22 -88 -14 -159t-114.5 -106.5t-176.5 -28.5q-89 7 -152 50t-85 101t-2.5 125t84.5 117l20 -27 q-47 -40 -67 -84.5t-13.5 -82.5t28.5 -73.5t61 -59.5t83 -38.5t94.5 -13t95.5 19.5q59 24 91.5 68t35.5 92t-8 99q-14 52 -74 92t-148 57q-135 26 -177 88q-27 37 -24.5 88t38.5 94q44 54 123 63.5t142.5 -30t65.5 -110.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 671,
    d: "M531 215l68 -3q-14 -66 -31 -101q-11 -22 -30 -44q-18 -21 -41 -35q-40 -26 -98 -29h-25q-9 0 -25 2q-21 2 -49 13q-22 10 -45 26q-24 20 -36 37q-28 38 -42 94q-10 41 -10 99l1 96q0 73 2 206.5t2 176.5v14h-37q-11 -1 -32 -2t-32 -1q-69 -3 -129 -13l-1 64 q60 -10 130 -13q11 0 32 -1t32 -1l37 -1l2 145v96l1 48q0 32 -7 48l64 -1q-8 -18 -8 -48l-1 -48l-1 -95l-2 -145q37 0 109 4q65 3 129 12v-64q-75 11 -129 13q-56 3 -110 3v-15q-2 -318 -4 -383l-2 -95q-2 -56 4 -91q6 -48 28 -84q24 -40 64 -58q19 -9 43 -12q18 -3 45 1 q49 5 82 29q32 24 46 70q11 37 6 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 786,
    d: "M282 3q-93 0 -158 57t-65 149v572h50v-572q0 -96 58 -143.5t131 -46.5q69 1 132 40t63 102v620h45v-663q0 -57 32 -57q31 0 60 47q15 25 22 55l32 -24q-24 -38 -51 -61.5t-52.5 -30.5t-48.5 11t-36 61q-22 -50 -81.5 -83t-132.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 587,
    d: "M236 115l218 666h31l-261 -778l-224 778h48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 960,
    d: "M807 781h22l-258 -778l-157 572l-157 -572l-257 778h21l224 -670l145 523h44l150 -521z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 741,
    d: "M639 51l-33 -49l-284 351l-282 -350l-11 9l284 352l-313 386l48 31q58 -126 281 -398l291 361l10 -8l-293 -363q91 -110 173.5 -198.5t128.5 -123.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 839,
    d: "M710 781h28q-33 -107 -355 -839l-107 -261q-39 -83 -92 -123t-127 -44q-51 -2 -99.5 15.5t-70.5 33t-33 27.5l36 47q4 -16 14.5 -33.5t29 -37.5t51.5 -31.5t74 -9.5q47 2 95 42.5t91 123.5l171 408l-373 678h62l339 -625q232 531 266 629z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 806,
    d: "M532 36q114 4 173 9v-42q-59 5 -173 9q-14 0 -42.5 1t-43.5 1h-86q-115 0 -173 -2q-154 -4 -187 -9l597 739q-36 3 -108 5q-12 1 -35 1t-34 1l-70 1q-70 0 -140 -3q-106 -5 -139 -8v42q48 -5 139 -9q47 -2 140 -2h70q11 0 34 1t35 1q140 6 159 8l-567 -739q69 -4 106 -5 q58 -2 173 -2h86q15 0 43.5 1t42.5 1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 755,
    d: "M623 785l30 -2q-10 -73 -40 -124q-23 -34 -41 -47q-28 -21 -54 -26q-62 -19 -117 19q-31 21 -81 84q-7 10 -19 26l-19.5 26t-17.5 21.5t-19 18.5q-58 45 -107 31q-56 -16 -84 -75q-27 -53 -24 -117l-30 3q10 72 40 123q23 34 41 47q27 20 55 26q57 17 117 -24 q11 -7 23.5 -21t21.5 -25.5t25 -33t23 -31.5q34 -45 59 -64q56 -43 111 -28t84 76q26 51 23 117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonbreakingspace",
    unicode: "\xA0",
    horizAdvX: 722
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewXpossibleFontRegular);
export default __webpack_public_path__ + "static/media/NewXpossibleFontRegular.76d05752ef4b59e53015a6205f39b826.svg";
export { ForwardRef as ReactComponent };